import { render, staticRenderFns } from "./MainLayoutFooter.vue?vue&type=template&id=e908e9b8&"
import script from "./MainLayoutFooter.vue?vue&type=script&lang=js&"
export * from "./MainLayoutFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports